import { useState, useEffect, useRef } from 'react';

import { useReward } from '@/contexts/reward-context';

import { TicketNewIcon } from '../../components/svg-icons';

const SBC_STORAGE_KEY = 'persist:is-reward-sbc-tooltip-shown';

export const RewardSbcTooltip = () => {
	const { labels } = useReward();
	const [isShow, setIsShow] = useState(false);
	const timerRef = useRef<ReturnType<typeof setTimeout>>();
	
	useEffect(() => {
		const isTooltipShown = localStorage.getItem(SBC_STORAGE_KEY) === 'true';
		
		if (!isTooltipShown) {
			setIsShow(true);

			clearTimeout(timerRef.current);
			timerRef.current = setTimeout(
				() => {
					setIsShow(false);
					localStorage.setItem(SBC_STORAGE_KEY, 'true');
				}, 
				5000
			);
		}

		return () => {
			clearTimeout(timerRef.current);
		};
	}, []);

	return (
		<div 
			className="reward-tooltip-sbc"
			data-show={isShow}
		>
			<TicketNewIcon />
			<div className="reward-tooltip-sbc__text">{labels?.lbl_SBCoffer}</div>
		</div>
	);
};